import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'

const Container = styled.div`
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  background-color: ${(props) => props.theme.palette.primary.pink50};
`

interface PaymentProcessingMessageProps {
  timedOut: boolean
}

const PaymentProcessingMessage = React.memo(
  (props: PaymentProcessingMessageProps) => {
    const { timedOut } = props

    return (
      <Container>
        <Text variant='body2' textColor={palette.grey.grey600}>
          {timedOut
            ? 'Your payment is still processing. Please check back shortly before continuing to vendor checkout.'
            : 'Waiting for your payment to process...'}
        </Text>
      </Container>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  PaymentProcessingMessage.displayName = 'PaymentProcessingMessage'
}

export default PaymentProcessingMessage
